import { ArrayFieldTemplateItemType } from "@rjsf/utils";
import IconButton from "@mui/material/IconButton";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

export const ArrayFieldItemTemplate = (props: ArrayFieldTemplateItemType) => {
  const { children, className, onDropIndexClick, index } = props;

  const handleRemove = () => {
    if (onDropIndexClick) {
      onDropIndexClick(index)();
    }
  };

  return (
    <div className="pulse-display-f pulse-align-center pulse-mt-1">
      <div className={className}>{children}</div>
      <IconButton aria-label="delete" size="small">
        <DeleteForeverIcon
          onClick={handleRemove}
          sx={{
            color: "#ebe93e",
            fontSize: 30,
            marginLeft: "10px",
          }}
        />
      </IconButton>
    </div>
  );
};
